module.exports = __webpack_public_path__ + "static/img/life-style4.333dca82.png";